/*
 * Module for the recalculation plan breakdown tab of Benefit Recalculation History screen
*/

rs.module("framework/benefitsummary/recalcplanbreakdown",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            // on plan change, reload plan breakdown
            $.js(jsSelectors.planSelect).change(function () {

                $.js(jsSelectors.loadingSpinner).show();

                $.get(
                    backendUrls.getPlanBreakdown,
                    {
                        bcpRCHistKey: $.js(jsSelectors.bcpRCHistKey).val(),
                        planKey: $(this).val()

                    }).done(function (result) {

                        $.js(jsSelectors.breakdownDetail).html(result);
                        $.js(jsSelectors.loadingSpinner).hide();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);